export default function ProblemSolution() {
  return (
    <section className="pt-8 pb-16 md:pt-12 md:pb-24 px-4 md:px-8 lg:px-12 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Left: Pain Points */}
          <div className="reveal">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-bold tracking-wide uppercase mb-4">
              El problema real
            </span>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4 leading-tight text-center">
              ¿ YA AGENDASTE TU{" "}
              <span className="text-accent-600">MANTENIMIENTO?</span>
            </h2>
            <p className="text-foreground-600 text-base md:text-lg mb-8 leading-relaxed">
              En Bogotá, los picos de calor pueden ser implacables. Y cuando tu
              equipo falla, no solo pierdes confort: pierdes productividad, ventas y
              tranquilidad.
            </p>

            <div className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/70 mb-8">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center shrink-0">
                  <i className="ri-error-warning-line text-accent-600 text-lg" />
                </div>
                <div>
                  <p className="font-heading font-bold text-foreground-900 text-lg mb-1">
                    3 de cada 10 equipos fallan en temporada de calor
                  </p>
                  <p className="text-foreground-600 text-sm leading-relaxed">
                    La mayoría por falta de mantenimiento preventivo. Una reparación
                    de emergencia cuesta hasta 5 veces más que un mantenimiento
                    programado.
                  </p>
                </div>
              </div>
            </div>

            <div className="space-y-4">
              {[
                {
                  icon: "ri-fire-line",
                  text: "Ambientes sofocantes que reducen la productividad de tu equipo en un 20%",
                },
                {
                  icon: "ri-flashlight-line",
                  text: "Equipos sin mantenimiento consumen hasta un 40% más energía",
                },
                {
                  icon: "ri-heart-pulse-line",
                  text: "Un mantenimiento bien hecho garantiza aire limpio y saludable en tu espacio",
                },
                {
                  icon: "ri-coins-line",
                  text: "Averías imprevistas que pueden costar entre $800K y $3M en reparaciones",
                },
              ].map((item, i) => (
                <div
                  key={i}
                  className="flex items-start gap-3 reveal"
                  style={{ transitionDelay: `${i * 120}ms` }}
                >
                  <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center shrink-0 mt-0.5">
                    <i className={`${item.icon} text-accent-600`} />
                  </div>
                  <p className="text-foreground-700 text-sm md:text-base leading-relaxed">
                    {item.text}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Right: Solution */}
          <div className="reveal lg:pl-6">
            <div className="bg-primary-50 rounded-2xl p-6 md:p-8 border border-primary-200/70">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center">
                  <i className="ri-shield-check-line text-background-50 text-lg" />
                </div>
                <span className="font-heading font-bold text-primary-800 text-lg">
                  La solución SERIN
                </span>
              </div>

              <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-3">
                Prevenimos fallas antes de que ocurran
              </h3>
              <p className="text-foreground-600 text-base leading-relaxed mb-6">
                Nuestro mantenimiento preventivo reduce el riesgo de averías en un{" "}
                <strong className="text-primary-700">94%</strong>. Más de 350
                empresas y hogares en Colombia ya confían en nosotros para mantener
                sus espacios climatizados sin sorpresas.
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-6">
                {[
                  { num: "94%", txt: "Menos averías con mantenimiento" },
                  { num: "40%", txt: "Ahorro en consumo energético" },
                  { num: "2h", txt: "Tiempo de respuesta promedio" },
                  { num: "1 año", txt: "Garantía en instalaciones" },
                ].map((s, i) => (
                  <div
                    key={i}
                    className="bg-background-50 rounded-lg p-4 border border-background-200/60"
                  >
                    <div className="font-heading text-xl font-bold text-primary-600 mb-0.5">
                      {s.num}
                    </div>
                    <div className="text-xs text-foreground-600">{s.txt}</div>
                  </div>
                ))}
              </div>

              <a
                href="https://wa.link/b002hg"
                className="block w-full text-center px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                <i className="ri-calendar-check-line mr-2" />
                Agendar asesoría
              </a>
              <p className="text-center text-xs text-foreground-500 mt-2">
                Sin compromiso. Sin costo oculto.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}